/**
 * ApprovalsBell — topbar bell icon with a badge showing count of approvals
 * pending the current user. Polls every 60s. Clicking navigates to /app/approvals.
 */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ApprovalsBell() {
  const nav = useNavigate();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let dead = false;
    const load = () => api.get("/approvals-v2/inbox")
      .then((r) => { if (!dead) setCount((r.data.pending || []).length); })
      .catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { dead = true; clearInterval(t); };
  }, []);

  return (
    <Button variant="ghost" size="sm" className="h-9 rounded-sm relative"
              onClick={() => nav("/app/approvals/inbox")}
              data-testid="topbar-approvals-bell"
              title="Pending Approvals">
      <Bell className="w-4 h-4" />
      {count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] rounded-full bg-red-500 text-[10px] font-bold text-white flex items-center justify-center px-1"
                data-testid="approvals-badge">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Button>
  );
}
